// i18next-extract-mark-ns-start CoutureServices
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import HeaderBanner from '../../HeaderBanner';
import Intro from '../../Intro';
import WorksBanner from '../../WorksBanner';
import OurRanges from './OurRanges';
import HowItWorksBlock from '../HowItWorksBlock';
import AllServices from './AllServices';
import TipsServices from './TipsServices';
import SpecialRequest from './SpecialRequest';
import FAQBlock from '../../FAQBlock';
import withAppContext from '../../../withAppContext';
import { isMultilingual } from '../../../../languages';

// assets
import CoutureBanner from '../../../assets/ourServices/couturier/couture.banner.jpg';
import dressing from '../../../assets/ourServices/couturier/dressing.range.jpg';
import intérieur from '../../../assets/ourServices/couturier/interieur.range.jpg';
import accessoires from '../../../assets/ourServices/couturier/accessoires.range.jpg';
import bonusRéparation from '../../../json/images/laRubrique/BonusReparation.2.jpg';
import robeCombishort from '../../../json/images/laRubrique/v3/commentTransformerUneRobeEnCombishort.1.jpg';
import demandeCouture from '../../../assets/ourServices/demande.couture.jpg';
import demandeCoutureMobile from '../../../assets/ourServices/demande.couture.mobile.jpg';

const getCouturierRanges = (t) => [
  {
    image: dressing,
    title: t('Vêtements : pantalon, jean, robe de mariée, veste, tailleur'),
    key: 'dressing',
  },
  {
    image: intérieur,
    title: t('Décoration : rideau, plaid, coussin, nappe'),
    key: 'interior',
  },
  {
    image: accessoires,
    title: t('Accessoires : sac, écharpe, bonnet'),
    key: 'accessories',
  },
];

const getCoutureArticles = (t) => [
  {
    image: bonusRéparation,
    title: t('Bonus réparation'),
    text: t(
      // eslint-disable-next-line max-len
      'Dans un monde où la prise de conscience environnementale prend une place de plus en plus importante, l‘allongement de la durée de vie de nos biens de consommation est devenu un enjeu majeur.',
    ),
    link: '/bonus-reparation/',
  },
  {
    image: robeCombishort,
    title: t('De robe à combishort'),
    text: t(
      // eslint-disable-next-line max-len
      'Besoin d’une petite combishort pour l’été ? Pourquoi ne pas upcycler/transformer ses vieux vêtements comme cette robe qui dort au fond de votre placard depuis maintenant 3 ans ? Nos Tillistes sont là pour vous proposer mille et une solutions pour transformer votre jolie robe en une combi-short à la hauteur des derniers défilés (et oui, rien que ça) !',
    ),
    link: '/la-rubrique/comment-transformer-une-robe-en-combishort/',
  },
];

function CoutureServices({
  context: { isMobile }, locality, faqQuestions, preFilledSteps, preSelectedRange, arrondissement, articles,
}) {
  const { t } = useTranslation();
  const title = locality ? t('Nos services de couture à {{locality}} {{arrondissement}}', { locality, arrondissement: arrondissement || '' })
    : t('Un couturier pour réparer \net retoucher vos vêtements');
  return (
    <>
      <HeaderBanner
        image={CoutureBanner}
        title={title}
        text={t(
          'Nos artisans couturiers vous accompagnent à réparer, ajuster ou réinventer vos vêtements !',
        )}
        preFilledSteps={preFilledSteps}
      />
      <Intro work="couture" title={t('Une retoucherie à proximité, \nà domicile et en ligne')} />
      <WorksBanner />
      <OurRanges
        ranges={getCouturierRanges(t)}
        preSelectedRange={preSelectedRange}
        title={t('Retouche et couture')}
        subtitle={t('Ce que nos artisans peuvent réparer et retoucher')}
      />
      <HowItWorksBlock />
      <AllServices />
      {!isMultilingual && (
        <TipsServices articles={articles || getCoutureArticles(t)} />
      )}
      <SpecialRequest background={isMobile ? demandeCoutureMobile : demandeCouture} />
      {faqQuestions && (
        <FAQBlock questions={faqQuestions} />
      )}
    </>
  );
}

CoutureServices.propTypes = {
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
  locality: PropTypes.string,
  faqQuestions: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string,
    answer: PropTypes.string,
  })),
  preFilledSteps: PropTypes.shape({
    selectedCloth: PropTypes.string,
    selectedFabric: PropTypes.string,
  }),
  preSelectedRange: PropTypes.string,
  arrondissement: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.shape({})),
};

CoutureServices.defaultProps = {
  locality: null,
  faqQuestions: null,
  preFilledSteps: null,
  preSelectedRange: 'interior',
  arrondissement: null,
  articles: null,
};

export default withAppContext(CoutureServices);
